import React from 'react';
import LeaguePage from '../../components/LeaguePage/LeaguePage';
import GeneralLayout from '../../layouts/GeneralLayout'

const League = () => {
  return (
    <div>
        <GeneralLayout>
            <LeaguePage />
        </GeneralLayout>
    </div>
  )
}

export default League